import cn from 'classnames';
import { ComponentProps, ReactElement, forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

// to be deprecated

interface ExecutionInputWrapperProps extends ComponentProps<'input'> {
    label?: string;
    className?: string;
    children: ReactElement;
    hasTooltipIcon?: boolean;
}

const ExecutionInputWrapper = forwardRef<HTMLInputElement, ExecutionInputWrapperProps>((props, ref) => {
    const { name, label, children, hasTooltipIcon = false, ...rest } = props;
    const { required, disabled } = rest;
    const { control } = useFormContext();

    return (
        <div className="flex flex-col gap-1 text-brand-text w-full">
            {label ? (
                <label
                    className={cn('relative text-sm', {
                        'w-[calc(100%-20px)]': hasTooltipIcon
                    })}>
                    {label}
                    {required && <span className="absolute -top-1 -right-1.5">*</span>}
                </label>
            ) : null}
            <div className="w-full">{children}</div>
        </div>
    );
});

ExecutionInputWrapper.displayName = 'ExecutionInputWrapper';

export default ExecutionInputWrapper;
